import { ButtonV2 } from '@cimplico/components';
import { useState } from 'react';
import { useFileReferences } from '../../queries/use-file-references';
import FilePathSection from './FilePathSection';

type FileReferencesProps = {
    fileId: string;
    sourceFileId: string;
    inContext: boolean;
    onGoToFolder: (folderId: string, activeFileId?: string) => void;
};

function FileReferences({ fileId, sourceFileId, inContext, onGoToFolder }: FileReferencesProps): JSX.Element {
    const [showMore, setShowMore] = useState(false);
    const fileReferencesQuery = useFileReferences(sourceFileId);

    if (fileReferencesQuery.isLoading) {
        return <></>;
    }

    if (!fileReferencesQuery.isSuccess) {
        return <></>;
    }

    const { references } = fileReferencesQuery.data;

    const currentReference = references.find((ref) => ref.path[ref.path.length - 1].id === fileId);

    return (
        <section className="mt-8">
            <p className="font-medium pb-2 border-b text-gray-800 mt-8">References</p>
            {references.length === 0 && <p className="py-3 text-sm font-medium text-gray-500">-</p>}
            {references.length > 0 && (
                <>
                    {currentReference && (
                        <FilePathSection
                            filePath={currentReference.path}
                            onGoToFolder={onGoToFolder}
                            inContext={inContext}
                            isCurrent={currentReference.path[currentReference.path.length - 1].id === fileId}
                        />
                    )}
                    {references
                        .filter((ref) => ref.id !== currentReference?.id)
                        .map((ref, idx) => {
                            if (references.length > 5 && !showMore && (currentReference ? idx > 3 : idx > 4)) {
                                return <div key={idx}></div>;
                            }
                            return (
                                <FilePathSection
                                    key={idx}
                                    filePath={ref.path}
                                    onGoToFolder={onGoToFolder}
                                    isCurrent={ref.path[ref.path.length - 1].id === fileId}
                                />
                            );
                        })}
                </>
            )}
            {references.length > 5 && (
                <div className="pt-2">
                    <ButtonV2
                        size="xs"
                        type="hollow"
                        label={showMore ? 'Show less' : 'Show more'}
                        onClick={(): void => setShowMore(!showMore)}
                    />
                </div>
            )}
        </section>
    );
}

export default FileReferences;
